import { CustomError } from 'ts-custom-error';

export class PageNotFoundError extends CustomError {}
